import {requestPoolSize} from '../utils/featureToggles'
import {defaultRequestPoolSize, RequestsPool} from '../utils/requestQueue'

export const buildDetailsQueue = new RequestsPool(requestPoolSize ?? defaultRequestPoolSize)
